/**
 * <s-front-back-toggle> — Switches the product page image between the front and back print.
 *
 * Commands (dispatched via commandfor/command on descendant buttons):
 *   --show-prev — Show the other side.
 *   --show-next — Show the other side.
 *
 * Required child markup:
 *   [data-face]       — One slide per side; all but the active one carry `hidden`.
 *   [data-face-label] — Text node that names the visible side.
 */
class SFrontBackToggle extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    this.addEventListener('command', (e) => {
      if (e.command === '--show-prev' || e.command === '--show-next') this.#flip();
    }, { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #flip() {
    const faces = [...this.querySelectorAll('[data-face]')];
    if (faces.length < 2) return;
    const current = faces.findIndex((face) => !face.hidden);
    const next = faces[(current + 1) % faces.length];
    faces.forEach((face) => { face.hidden = face !== next; });
    const label = this.querySelector('[data-face-label]');
    if (label && next.dataset.faceName) label.textContent = next.dataset.faceName;
  }
}

if (!customElements.get('s-front-back-toggle')) {
  customElements.define('s-front-back-toggle', SFrontBackToggle);
}
